<template>
  <div class="container">
    <div class="alert alert-danger" v-if="error" role="alert">
      {{ error }}
    </div>
    <h3>Vill du radera Noteringen?</h3>
    <p>
      {{ note.Notes }}
    </p>
    <button type="button" class="btn btn-link" @click="$router.go(-1)">Avbryt</button>
    <button type="submit" class="btn btn-danger" @click="deleteNote">Radera</button>
  </div>
</template>
<script>
import appService from '../appService'

export default {
  props: ['id'],

  data () {
    return {
      error: '',
      note: {}
    }
  },

  created () {
    appService.getNote(this.id)
    .then((data) => { this.note = data })
  },

  methods: {
    deleteNote () {
      appService.deleteNote(this.id)
      .then(() => { this.$router.go(-1) })
      .catch((err) => { this.error = err.response.data })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/NoteDelete.vue